import { useState } from "react";
import Sidebar from "../components/layout/Sidebar";
import PointsIssuanceChart from "../components/dashboard/PointsIssuanceChart";
import TopCustomersTable from "../components/dashboard/TopCustomersTable";
import RecentReferrals from "../components/dashboard/RecentReferrals";
import { useTopCustomers } from "../services/dashboard";

const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { data: customers, isLoading: customersLoading, isError: customersError } = useTopCustomers({ limit: 5 });

  return (
    <div className="flex h-screen overflow-hidden bg-surface-page">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <main className="flex-1 min-w-0 overflow-y-auto px-4 sm:px-8 lg:pl-11 lg:pr-8 pt-6 lg:pt-[60px] pb-16">
        {/* Mobile header */}
        <div className="flex items-center justify-between mb-4 lg:hidden">
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-2 rounded-lg hover:bg-black/5 transition-colors"
            aria-label="Open menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="#012926" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        <h1
          className="text-[28px] sm:text-[34px] uppercase tracking-[0.68px] leading-none text-brand-dark"
          style={{ fontFamily: '"Bebas Neue", sans-serif' }}
        >
          Dashboard
        </h1>
        <p className="mt-3 text-[14px] sm:text-[16px] font-medium text-content-label">
          Real-time overview of program health and customer engagement.
        </p>

        <div className="mt-8 lg:mt-[36px] flex flex-col gap-8 lg:gap-[60px]">
          <PointsIssuanceChart />
          <div className="flex flex-col xl:flex-row gap-8 xl:gap-[60px] items-start">
            <TopCustomersTable customers={customers} isLoading={customersLoading} isError={customersError} />
            <RecentReferrals />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
